    import axiosAuth from '../../../shared/configs/axios-auth'

    const getDefaultState = () => {
        return {
            countries: null,
        }
    }
    
    const state = getDefaultState()

    const getters = {
        countries: state => {
            return state.countries
        },
    }

    const mutations = {
        resetState (state) {
            Object.assign(state, getDefaultState())
        },
        countries: (state, payload) => {
            state.countries = payload
        },
    }

    const actions = {
       
        getCountries: ({commit}) =>{
            commit('updating', true)
            axiosAuth.get('/countries')
            .then(
                res => {
                    commit('updating', false)
                    commit('countries', res.data)
                }
              )
              .catch(
                error => {
                  console.log(error.response)
                  commit('updating', false)
                }
              )
        }
    }

    export default {
        state,
        getters,
        mutations,
        actions
    }